import { IconWrapper } from '../runtime';
export default IconWrapper('revoke', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M1.31272 3.49657C0.890083 3.77727 0.897131 4.40032 1.32601 4.67139L4.90758 6.93512C5.37368 7.22972 5.98158 6.89479 5.98157 6.34339C5.98153 3.92453 5.98153 4.09773 5.98149 1.70092C5.98148 1.14238 5.35947 0.808808 4.89421 1.11783L1.31272 3.49657Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M4 3.99976H9.125C11.9555 3.99976 14.25 6.2943 14.25 9.12476V9.12476C14.25 11.9552 11.9555 14.2498 9.125 14.2498H5.75",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});